import { $window } from '../../helpers/globalVars';
import { customDots } from '../../helpers/slick';

const handler = ( $ ) => {
	const elWindow = {
			width: $window.width(),
			height: $window.height(),
		},
		$markers = $( '.map-marker' ),
		$mapPartnerList = $( '.map__partner-list' ),
		$partnerModals = $( '.map__partner-item', $mapPartnerList );

	if ( $markers.length == 0 ) {
		return;
	}

	$markers.each( function ( _, el ) {
		const $marker = $( el );

		if ( $marker.length == 0 ) {
			return;
		}

		const $relatedPartnerModal = $(
			`[data-partner-id="${ $marker.data( 'partner-id' ) }"`
		);

		if ( $relatedPartnerModal.length == 0 ) {
			return;
		}

		let relatedPartnerStatus = $relatedPartnerModal.attr(
			'data-partner-status'
		);

		if ( typeof relatedPartnerStatus == 'undefined' ) {
			return;
		}

		relatedPartnerStatus.trim();

		$marker
			.attr( 'data-partner-status', relatedPartnerStatus )
			.find( '.map-marker__circle' )
			.addClass( 'is-visible' );
	} );

	const showPartnerModal = ( $pModal ) => {
		$pModal.fadeIn( 300 ).attr( 'data-is-visible', 'yes' );
	};

	const hidePartnerModal = ( $pModal ) => {
		$pModal.fadeOut( 300 ).attr( 'data-is-visible', 'no' );
	};

	const markersClickHandler = function ( e ) {
		e.preventDefault();

		$markers.filter( '.is-active' ).removeClass( 'is-active' );

		const $clickedMarker = $( this ),
			$relatedPartnerModal = $(
				`[data-partner-id="${ $clickedMarker.data( 'partner-id' ) }`
			),
			$visiblePartnerModals = $partnerModals
				.not( $relatedPartnerModal )
				.filter( '[data-is-visible="yes"]' );

		$clickedMarker.addClass( 'is-active' );

		if ( $relatedPartnerModal.length == 0 ) {
			return;
		}

		const mapContainerPosition =
				$( '.map__container' )[ 0 ].getBoundingClientRect(),
			markerPosition = $clickedMarker[ 0 ].getBoundingClientRect(),
			relativePos = {
				top: markerPosition.top - mapContainerPosition.top,
				left: markerPosition.left - mapContainerPosition.left,
			},
			rightEdgeDistance = elWindow.width - markerPosition.left - 20,
			bottomEdgeDistance = elWindow.height - markerPosition.top - 5,
			pModalPosition = {};

		if ( rightEdgeDistance < $relatedPartnerModal.width() ) {
			pModalPosition.left =
				markerPosition.left - 50 - $relatedPartnerModal.width();
		} else {
			pModalPosition.left = relativePos.left - 20;
		}

		if ( bottomEdgeDistance < $relatedPartnerModal.height() ) {
			pModalPosition.top =
				relativePos.top - 65 - $relatedPartnerModal.height();
		} else {
			pModalPosition.top = relativePos.top - 5;
		}

		$relatedPartnerModal.css( {
			top: `${ pModalPosition.top }px`,
			left: `${ pModalPosition.left }px`,
		} );

		if ( $visiblePartnerModals.length > 0 ) {
			hidePartnerModal( $visiblePartnerModals );
		}

		showPartnerModal( $relatedPartnerModal );
	};

	const windowClickHandler = ( e ) => {
		const $visiblePartnerModal = $partnerModals.filter(
				'[data-is-visible="yes"]'
			),
			$activedMarker = $(
				`[data-partner-id="${ $visiblePartnerModal.data(
					'partner-id'
				) }`
			),
			hasVisiblePartnetModal = $visiblePartnerModal.length > 0,
			isPartnerModalOutClick =
				! $partnerModals.is( e.target ) &&
				$partnerModals.has( e.target ).length == 0,
			isNotClickOnMarker =
				! $markers.is( e.target ) &&
				$markers.has( e.target ).length == 0;

		if (
			isPartnerModalOutClick &&
			hasVisiblePartnetModal &&
			isNotClickOnMarker
		) {
			$activedMarker.removeClass( 'is-active' );

			hidePartnerModal( $visiblePartnerModal );
		}
	};

	const windowResizeHandler = () => {
		elWindow.width = $window.width();
		elWindow.height = $window.height();
		slickInit();
	};

	const slickInit = () => {
		if ( elWindow.width < 992 ) {
			$mapPartnerList.not( '.slick-initialized' ).slick( {
				infinite: false,
				arrows: false,
				dots: true,
				variableWidth: true,
				touchThreshold: 10,
				speed: 150,
			} );
		} else {
			$mapPartnerList.filter( '.slick-initialized' ).slick( 'unslick' );
		}
	};

	$mapPartnerList.on( 'init', customDots );
	$markers.on( 'click', markersClickHandler );
	$window.on( 'click', windowClickHandler );
	$window.on( 'resize', windowResizeHandler ).trigger( 'resize' );
};

( ( $ ) => {
	$( handler );
} )( jQuery );
